module.exports = __webpack_public_path__ + "img/stars.8bddd312.svg";